const en = {
    rateLabel: 'Rate your experience',
    textAreaLabel: 'Comment/Complaint/Feedback (Optional)',
    contactBackLabel: 'I want Sprinkle staff to contact me back',
    contactNameLabel: 'Contact name',
    mobileLabel: 'Mobile No.',
    emailLabel: 'E-mail',
    inquiriesLabel: 'For inquiries',
    copyrightsLabel: '2013 M. Water Company Limited. All rights reserved.',
    submitButtonLabel: 'Confirm',
    thankLabel: 'Thank you for your feedback',
    thankSubLabel: 'Your response will be used to improve our service',
    thankContactSubLabel: 'Our staff will contact you back shortly',
    thankPerfectLabel: 'Thank you',
    thankPerfectSubLabel: 'for helping us improve!',
    thankGoogleLabel1: 'We always strive to be better,and your feedback will help us accomplish that.',
    thankGoogleLabel2: 'Share you experience with others.',
    oneStar: 'Very Unsatisfied',
    twoStar: 'Unsatisfied',
    threeStar: 'Neutral',
    fourStar: 'Satisfied',
    fiveStar: 'Very Satisfied',
    lowShortcutBtn: 'Unpunctuality,Poor Service Mind,Incorrect Order,Incorrect Information,Product Quality',
    highShortcutBtn: 'Punctuality,Politeness,Correct Order,Product Quality,Contactless Delivery',
    buyCouponLabel: 'Buy Coupon',
    deliveryTrackingLabel: 'Delivery Tracking',
    contactBackSubjectLabel: 'Reason'
}

const th = {
    rateLabel: 'คะแนนความพึงพอใจ',
    textAreaLabel: 'ข้อคิดเห็น/ข้อร้องเรียน/ข้อเสนอแนะ (ไม่จำเป็น)',
    contactBackLabel: 'ต้องการให้สปริงเคิลติดต่อกลับ',
    contactNameLabel: 'ชื่อผู้ติดต่อ',
    mobileLabel: 'เบอร์โทรศัพท์',
    emailLabel: 'อีเมล',
    inquiriesLabel: 'มีข้อสงสัย',
    copyrightsLabel: 'สงวนลิขสิทธิ์ 2556 บริษัท เอ็ม. วอเตอร์ จำกัด',
    submitButtonLabel: 'ยืนยัน',
    thankLabel: 'ขอบคุณสำหรับความคิดเห็นของท่าน',
    thankSubLabel: 'เราจะนำความคิดเห็นของท่านมาปรับปรุงการให้บริการของเรา',
    thankContactSubLabel: 'สปริงเคิลจะติดต่อท่านกลับโดยเร็ว',
    thankPerfectLabel: 'ขอบคุณ',
    thankPerfectSubLabel: 'สำหรับความคิดเห็นของท่าน',
    thankGoogleLabel1: 'เราพยายามทำให้ดีขึ้นอยู่เสมอ',
    thankGoogleLabel2: 'แบ่งปันประสบการณ์ของคุณกับผู้อื่น',
    oneStar: 'ไม่พึงพอใจมาก',
    twoStar: 'ไม่พึงพอใจ',
    threeStar: 'ปานกลาง',
    fourStar: 'พึงพอใจ',
    fiveStar: 'พึงพอใจมาก',
    lowShortcutBtn: 'จัดส่งไม่ตรงเวลา,บริการไม่สุภาพ,ได้รับน้ำดื่มไม่ครบ,ได้รับข้อมูลไม่ถูกต้อง,คุณภาพน้ำดื่ม/สินค้า',
    highShortcutBtn: 'จัดส่งตรงเวลา,บริการสุภาพ,ได้รับน้ำดื่มครบ,คุณภาพน้ำดื่ม/สินค้า,ลดการสัมผัส',
    buyCouponLabel: 'สั่งซื้อคูปอง',
    deliveryTrackingLabel: 'ติดตามรอบส่งน้ำ',
    contactBackSubjectLabel: 'เรื่องที่ต้องการให้ติดต่อกลับ'
}

const contactBackSubjects = [
    {
        en: 'Report Delivery Issues',
        th: 'ร้องเรียนปัญหาด้านการจัดส่งน้ำดื่ม'
    },{
        en: 'Report Service Issues',
        th: 'ร้องเรียนปัญหาเรื่องมารยาทการให้บริการ'
    },{
        en: 'Report Product Issues',
        th: 'ร้องเรียนปัญหาคุณภาพน้ำดื่ม,ถังน้ำ'
    },{
        en: 'Other Issues',
        th: 'ร้องเรียนปัญหาอื่นๆ '
    }
]

export {
    en,
    th,
    contactBackSubjects
}